import { Dialog } from "quasar";
import { QDialogOptions } from "quasar";

export default function useDialog(title: string, message: string) {

  Dialog.create({
    title,
    message,
    style: "max-width: 90vw;"
  } as QDialogOptions)
}
